import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  title: {
    alignSelf: 'center',
    fontFamily: 'Montserrat_700Bold',
    color: '#140C78',
    textAlign: 'center',
    width: '80%',
  },

  subtitle: {
    alignSelf: 'center',
    fontFamily: 'Lato',
    color: '#140C78',
    textAlign: 'center',
    width: '80%',
  },
});
